import { siteUrl } from "../../config";
export default async ({ auth, body }) =>
  fetch(siteUrl, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: auth ? `Bearer ${auth}` : ""
    },
    method: "POST",
    body: body ? body : null
  })
    .then(res => res.json())
    .then(res => {
      if (!res.data) throw res.errors;
      return res.data;
    })
    .catch(err => {
      throw err;
    });
